module.exports = {"511124001":"研城街道","511124101":"马踏镇","511124102":"竹园镇","511124103":"研经镇","511124104":"周坡镇","511124105":"千佛镇","511124106":"王村镇","511124107":"三江镇","511124108":"东林镇","511124110":"集益镇","511124111":"纯复镇","511124112":"宝五镇","511124113":"镇阳镇","511124114":"高凤镇","511124115":"门坎镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511124.json
// module id = 2465
// module chunks = 0